import script from "./fileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./fileUpload.vue?vue&type=script&setup=true&lang=js"

import "./fileUpload.vue?vue&type=style&index=0&id=413a7863&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-413a7863"]])

export default __exports__